export default {
    app: "/",
    login: "/login",
    error: "/error/:code?/:title?/"
};
